import z from "zod";

const githubErrorTypeValues = [
  "CODEOWNERS_FILE_NOT_FOUND",
  "FAILED_TO_PARSE_GITHUB_RESPONSE",
  "INVALID_GITHUB_WEBHOOK_PAYLOAD",
  "GITHUB_API_REQUEST_FAILED",
] as const;

const githubErrorTypeSchema = z.enum(githubErrorTypeValues);
const GithubErrorType = githubErrorTypeSchema.enum;
type GithubErrorType = z.infer<typeof githubErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GithubErrors =
  | {
      errorType: typeof GithubErrorType.CODEOWNERS_FILE_NOT_FOUND;
      data: undefined;
    }
  | {
      errorType: typeof GithubErrorType.FAILED_TO_PARSE_GITHUB_RESPONSE;
      data: { route: string; errorMessage: string };
    }
  | {
      errorType: typeof GithubErrorType.INVALID_GITHUB_WEBHOOK_PAYLOAD;
      data: { errorMessage: string };
    }
  | {
      errorType: typeof GithubErrorType.GITHUB_API_REQUEST_FAILED;
      data: { route: string; errorMessage: string };
    };

export const githubErrorDetails: Record<GithubErrorType, ErrorDetails> = {
  [GithubErrorType.CODEOWNERS_FILE_NOT_FOUND]: {
    sentryDescription: "Codeowners file not found",
  },
  [GithubErrorType.FAILED_TO_PARSE_GITHUB_RESPONSE]: {
    sentryDescription: "Failed to parse GitHub API response",
  },
  [GithubErrorType.INVALID_GITHUB_WEBHOOK_PAYLOAD]: {
    sentryDescription: "Invalid GitHub webhook payload",
  },
  [GithubErrorType.GITHUB_API_REQUEST_FAILED]: {
    sentryDescription: "GitHub API request failed",
  },
};
